// @ts-strict-ignore
import {getProjectId, getWorkspaceId} from 'common/report/util';
import type {EventParams} from 'common/util/definitions-types';

import {queryApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class QApiEventDefinitionsClient extends BaseClient {
  buildEndpoint() {
    return queryApiUrl(`data_definitions/events`);
  }

  buildQueryParams({useQueryCache = null}: EventParams = {}) {
    return {
      // TODO: support these in the backend first
      // id,
      // name,
      // customEventId,
      // collectEverythingEventId,
      ...(useQueryCache !== null ? {use_query_cache: useQueryCache} : {}),
      project_id: getProjectId(),
      ...(getWorkspaceId() ? {workspace_id: getWorkspaceId()} : {}),
    };
  }

  processResponse(response) {
    return response.results;
  }
}

export const qapiEventDefinitionsClient = new QApiEventDefinitionsClient();
